import { section } from "@/glow";
import { animateStandard, shouldAnimate } from "@/lib/animation";

section("list-collections", {
  onLoad() {
    if (shouldAnimate(this.container)) {
      this.animateListCollections = animateStandard(this.container);
    }
  },

  onUnload() {
    this.animateListCollections?.destroy();
  },
});
